import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_prodsys_hdr_RowClass} from '../../dbschema/bl_mrp_prodsys_hdr.model';
import {bl_mrp_prodsys_ext_RowClass} from '../../dbschema/bl_mrp_prodsys_ext.model';
import {bl_mrp_prodsys_line_RowClass} from '../../dbschema/bl_mrp_prodsys_line.model';

export class MrpProdsysContainerModel extends BaseContainerModel {
  bl_mrp_prodsys_hdr:  bl_mrp_prodsys_hdr_RowClass = new  bl_mrp_prodsys_hdr_RowClass();
  bl_mrp_prodsys_exts:  bl_mrp_prodsys_ext_RowClass[] = [];
  bl_mrp_prodsys_lines: bl_mrp_prodsys_line_RowClass[] = [];
}
